import { Navbar } from "@blueprintjs/core"
import React from "react"
import classNames from "utils/classNames"
import VesatogoBrand from "../../Atoms/VesatogoBrand"
import styles from "./styles.module.css"
const AppNavbar = ({
  heading = <VesatogoBrand />,
  className,
  children,
  ...OtherNavbarProps
}) => {
  return (
    <div className={classNames("sticky top-0 z-[18]", className)}>
      <Navbar
        className={classNames(
          "flex justify-between h-16 shadow-none bg-white",
          styles["navbar"]
        )}
        {...OtherNavbarProps}
      >
        <Navbar.Group className="h-full">{heading}</Navbar.Group>
        <Navbar.Group className="h-full">{children}</Navbar.Group>
      </Navbar>
    </div>
  )
}

export default AppNavbar
